import { gerarUuid } from "@/shared/http/gerar-uuid";
import { useMemo, useState } from "react";
import { Button } from "@base/ui/renke";
import { LogoRenkeRefs } from "../../../shared/branding/logo-renke-refs";
import { fonteDeTokenDoNavegador } from "../../../shared/auth/token";

function parametrosDoHash(): URLSearchParams {
  const hash = window.location.hash.replace(/^#/, "");
  const consulta = hash.includes("?") ? hash.slice(hash.indexOf("?") + 1) : "";
  return new URLSearchParams(consulta);
}

/**
 * Tela que o ChatGPT abre depois do login. Permitir devolve o código pro chat.
 */
export function PaginaConsentimentoOauth() {
  const params = useMemo(() => parametrosDoHash(), []);
  const clientId = params.get("client_id") ?? "";
  const redirectUri = params.get("redirect_uri") ?? "";
  const codeChallenge = params.get("code_challenge") ?? "";
  const [erro, definirErro] = useState<string | null>(null);
  const [enviando, definirEnviando] = useState(false);
  const incompleto = !clientId || !redirectUri || codeChallenge.length < 43;
  const deOnde = clientId.includes("claude.ai") ? "Claude" : "ChatGPT";

  async function responder(permitir: boolean) {
    definirErro(null);
    definirEnviando(true);
    try {
      const token = fonteDeTokenDoNavegador().tokenAtual();
      const resposta = await fetch(
        `${import.meta.env.VITE_URL_DA_API ?? ""}/api/oauth/consent`,
        {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: `Bearer ${token ?? ""}`,
            "idempotency-key": gerarUuid(),
          },
          body: JSON.stringify({
            client_id: clientId,
            redirect_uri: redirectUri,
            code_challenge: codeChallenge,
            code_challenge_method: "S256",
            state: params.get("state"),
            resource: params.get("resource"),
            permitir,
          }),
        },
      );
      const corpo = (await resposta.json()) as {
        redirect?: string;
        detail?: string;
        error_description?: string;
      };
      if (!resposta.ok || !corpo.redirect) {
        definirErro(
          corpo.error_description ??
            corpo.detail ??
            "Não deu para concluir. Tente conectar de novo.",
        );
        definirEnviando(false);
        return;
      }
      window.location.assign(corpo.redirect);
    } catch {
      definirErro("Não deu para concluir. Tente conectar de novo.");
      definirEnviando(false);
    }
  }

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-6">
      <div className="w-full max-w-md space-y-6 rounded-2xl border border-border-subtle bg-card px-6 py-8">
        <LogoRenkeRefs className="h-9" />
        <div className="space-y-2">
          <h1 className="text-xl font-semibold tracking-tight text-foreground">
            {incompleto ? "Link incompleto" : `Permitir o ${deOnde}?`}
          </h1>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {incompleto
              ? "Este endereço não veio da tela de conectar. Volte ao chat e crie o app de novo."
              : "Ele passa a ver a agenda da sua conta. Antes de gravar, o chat mostra o que vai mudar e espera o seu sim."}
          </p>
        </div>
        {erro ? (
          <p className="text-sm text-destructive" role="alert">
            {erro}
          </p>
        ) : null}
        {incompleto ? null : (
          <div className="flex flex-wrap gap-3">
            <Button
              type="button"
              variante="brand"
              tamanho="md"
              disabled={enviando}
              onClick={() => void responder(true)}
            >
              Permitir
            </Button>
            <Button
              type="button"
              variante="secondary"
              tamanho="md"
              disabled={enviando}
              onClick={() => void responder(false)}
            >
              Agora não
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
